'use client'

import { PropsWithChildren } from 'react'

import { PostHogProvider } from './posthog.tsx'
import { TanstackProvider } from './tanstack-provider.tsx'

export const SdkProvider = ({ children }: PropsWithChildren) => {
  return (
    <TanstackProvider>
      <PostHogProvider>{children}</PostHogProvider>
    </TanstackProvider>
  )
}
